/* ------------------------------------------------------------------
   «Yekpay Chat» — برنامهٔ نصبیِ گفتگو
   ------------------------------------------------------------------
   🔴 ۱۴۰۵/۰۸/۰۹ «pwa رو اوکی کن که دقیقا روی چت باز بشه و آیکون و اسم راکت‌چت نداشته باشه و به اسم Yekpay
   Chat نصب بشه». chat.kanzcard.com نمی‌تواند برنامهٔ نصبی باشد: manifest ندارد و CSP ِ Rocket.Chat جز از همان
   دامنه نمی‌پذیرد. پس برنامه همین نشانی از پنل است: فقط قابِ گفتگو، با همان ورودِ خودکار و همان اعلان.

   ⚠️ `scope` تنگ است (`/chat-app`): با `/` روی اندروید هر پیوندِ پنل در این برنامه باز می‌شد. ورود هم برای همین
   زیرِ همین مسیر است، وگرنه نوارِ نشانی وسطِ برنامه پیدا می‌شد.
   ------------------------------------------------------------------ */

export const CHAT_APP_PATH = '/chat-app'
export const CHAT_APP_NAME = 'Yekpay Chat'

export function isChatApp(pathname = window.location.pathname): boolean {
  return pathname === CHAT_APP_PATH || pathname.startsWith(`${CHAT_APP_PATH}/`)
}

/** نام و آیکونِ برنامه، پیش از نخستین رندر؛ مرورگر manifest را از همین پیوند می‌خواند. */
export function applyChatAppIdentity(): void {
  if (!isChatApp()) return

  const set = (selector: string, attribute: string, value: string) =>
    document.querySelector(selector)?.setAttribute(attribute, value)

  set('link[rel="manifest"]', 'href', '/yekpay-chat.webmanifest')
  set('link[rel="icon"]', 'href', '/icons/yekpay-chat/icon-192.png')
  set('link[rel="apple-touch-icon"]', 'href', '/icons/yekpay-chat/maskable-192.png')
  set('meta[name="apple-mobile-web-app-title"]', 'content', CHAT_APP_NAME)
  document.title = CHAT_APP_NAME
}
